import { render, staticRenderFns } from "./returnGoods.vue?vue&type=template&id=253a1674&"
import script from "./returnGoods.vue?vue&type=script&lang=js&"
export * from "./returnGoods.vue?vue&type=script&lang=js&"
import style0 from "./returnGoods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports